import { render } from "./B2bFiltersOcrDocuments.vue?vue&type=template&id=02fd345a&scoped=true&lang=pug"
import script from "./B2bFiltersOcrDocuments.vue?vue&type=script&lang=js"
export * from "./B2bFiltersOcrDocuments.vue?vue&type=script&lang=js"

import "./B2bFiltersOcrDocuments.vue?vue&type=style&index=0&id=02fd345a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02fd345a"]])

export default __exports__